export interface EnumConstantInterface {
    [state: string]: EnumOption;
}

export class EnumOption {
    cssClass = '';
    label = '-';
    order? = 0;
    description? = '';
}

export interface ResponseApiModel<T> {
    result: T;
}

/** @deprecated */
export interface ListingResponseApiModel<T> {
    result: {
        data: T[];
        pageIndex: number;
        totalCount: number;
        totalPages: number;
        perPage: number;
        take: number;
        skip: number;
    };
}

export interface ListingApiModel<T> {
    data: T[];
    pageIndex: number;
    totalCount: number;
    totalPages: number;
    perPage: number;
    take: number;
    skip: number;
}

export interface ApiErrorResponseApiModel {
    error: {
        code: string;
        name: string;
        messages: { message: string }[];
        status: number;
        statusCode: number;
    };
}

export interface SecurityTokenApiResponseModel {
    securityToken: string;
}
